import { render, staticRenderFns } from "./BibliaRegistros.vue?vue&type=template&id=a721dd20"
import script from "./BibliaRegistros.vue?vue&type=script&lang=js"
export * from "./BibliaRegistros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports